export default __webpack_public_path__ + "static/media/JoeriVanGeelen.4d47f6cc.png";